import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const CategoriesTypes = ({ form, categoriesTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Категория ТС">
      {getFieldDecorator('category_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите категорию ТС"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {categoriesTypes &&
            categoriesTypes.map(type => (
              <Option
                key={type.categoryKey}
                value={type.categoryKey}
                label={type.categoryName}
              >
                {type.categoryName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(CategoriesTypes, ['categoriesTypes']);
